import { RequestBooking } from '../../../shared/types';
import React, { createContext, useContext, useState } from 'react';

type ContextType<S> = [S, React.Dispatch<React.SetStateAction<S>>] | null;

const initialState = null;
const RequestBookingInfoContext = createContext<ContextType<RequestBooking>>(null);
RequestBookingInfoContext.displayName = 'RequestBookingInfoContext';

function useCurrentRequestBooking() {
    const context = useContext(RequestBookingInfoContext);
    if (!context) {
        throw new Error(`useCurrentRequestBooking must be used within a RequestBookingInfoProvider`);
    }

    const [currentRequestBooking, setCurrentRequestBooking] = context;

    return {
        currentRequestBooking,
        setCurrentRequestBooking,
    };
}

function RequestBookingInfoProvider(props) {
    const requestBooking = useState(initialState);
    return <RequestBookingInfoContext.Provider value={requestBooking} {...props} />;
}

export { RequestBookingInfoProvider, useCurrentRequestBooking };
